<template>
  <div>
    <mds-fieldset>
      <mds-combo-box
        :label="
          translate('scheduler.modal.parameters.dataset.holdings.view.label')
        "
        :data-set="viewOptions"
      ></mds-combo-box>
      <mds-combo-box
        :label="
          translate('scheduler.modal.parameters.dataset.holdings.number.label')
        "
        :data-set="numberOfHoldingsOptions"
      ></mds-combo-box>
      <mds-combo-box
        :label="
          translate(
            'scheduler.modal.parameters.dataset.holdings.frequency.label'
          )
        "
        :data-set="portfolioFrequencyOptions"
      ></mds-combo-box>
    </mds-fieldset>
  </div>
</template>

<script>
import MdsComboBox from '@mds/combo-box'
import MdsFieldset from '@mds/fieldset'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'

import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'HoldingsDatasetOptions',
  components: {
    MdsComboBox,
    MdsFieldset,
  },
  props: {
    viewOptions: {
      type: Array,
      default: () => [],
    },
    numberOfHoldingsOptions: {
      type: Array,
      default: () => [],
    },
    portfolioFrequencyOptions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>
